/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { ICocReadUserApproverStatusViewProps } from './coc-read-user-approver-status';
import Spinner from '../../themes/b2b/views/custom-components/spinner';

export default (props: ICocReadUserApproverStatusViewProps) => {
    return props.showLoader ? (
        <div>
            <Spinner text='Loading...' />
        </div>
    ) : null;
};
